import React, { useState } from 'react'
import { ClientLogsTab } from '@/components/activity-logs/ClientLogsTab'
import { BackOfficeLogsTab } from '@/components/activity-logs/BackOfficeLogsTab'

export const ActivityLogsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'client' | 'backoffice'>('backoffice')

  return (
    <div>
      {/* Tabs */}
      <div className="border-b border-[var(--color-border)] mb-6">
        <nav className="flex space-x-8">
          <button
            onClick={() => setActiveTab('backoffice')}
            className={`pb-4 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'backoffice'
                ? 'border-[var(--color-primary)] text-[var(--color-primary)] font-semibold'
                : 'border-transparent text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:border-[var(--color-border)]'
            }`}
          >
            BackOffice
          </button>
          <button
            onClick={() => setActiveTab('client')}
            className={`pb-4 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'client'
                ? 'border-[var(--color-primary)] text-[var(--color-primary)] font-semibold'
                : 'border-transparent text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:border-[var(--color-border)]'
            }`}
          >
            Client
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'backoffice' && <BackOfficeLogsTab />}
      {activeTab === 'client' && <ClientLogsTab />}
    </div>
  )
}
